// @ngInject
function UserPasswordResetDialogService($uibModal, $timeout) {

    return {
        showDialog: showDialog
    };

    function showDialog() {
        var modalDefaults = {
            backdrop: 'static',
            keyboard: false,
            controller: 'UserPasswordResetDialogServiceController as vm',
            templateUrl: 'services/dialogs/resetLogin/resetLogin.tpl.html',
            size: ''
        };

        modalDefaults.resolve = {
        };

        return $uibModal.open(modalDefaults).result;
    }
}

// @ngInject
function UserPasswordResetDialogServiceController($rootScope, $uibModalInstance, $scope, $interval, $translate,
    AuthService, ToasterService, $timeout) {
    var vm = this;

    //Properties
    vm.showPage = 0;
    vm.currentUser = {};
    vm.currentUser.email = '';
    vm.currentUser.tenantName = '';
    vm.currentUser.securityCode = '';
    vm.currentUser.newPassword = '';
    vm.currentUser.confirmPassword = '';
    vm.usernameOrEmail = '';
    vm.clickedResetPasswordButton = false;
    vm.clickedConfirmPasswordButton = false;

    //Methods
    vm.closeModal = closeModal;
    vm.resetPassword = resetPassword;
    vm.confirmNewPassword = confirmNewPassword;

    function activate() {
        if ($rootScope.currentUser !== undefined) {
            vm.currentUser = $rootScope.currentUser;
        }
    }

    function closeModal() {
        vm.showConfirmPassword = false;
        $uibModalInstance.close();
    }

    function resetPassword() {
        vm.clickedResetPasswordButton = true;
        if (vm.usernameOrEmail.length === 0 || vm.currentUser.tenantName.length === 0) {
            ToasterService.showError($translate.instant('common.errorMissingInputOrTenant'), $translate.instant('common.error'));
            vm.clickedResetPasswordButton = false;
            return;
        }
        if (!validateEmail(vm.usernameOrEmail)) {
            vm.currentUser.username = vm.usernameOrEmail;
            vm.currentUser.email = '';
        } else {
            vm.currentUser.email = vm.usernameOrEmail;
            vm.currentUser.username = '';
        }

        AuthService.resetPassword(vm.currentUser).then(function(response) {
            vm.showPage = 1;
        }, function(error) {
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
            vm.clickedResetPasswordButton = false;
        });
    }

    function confirmNewPassword() {
        vm.clickedConfirmPasswordButton = false;
        if (vm.currentUser.newPassword.length === 0 || vm.currentUser.confirmPassword.length === 0) {
            vm.clickedConfirmPasswordButton = true;
            ToasterService.showError($translate.instant('common.errorMissingPasswordOrConfirmation'), $translate.instant('common.error'));
            return;
        } else if (vm.currentUser.newPassword !== vm.currentUser.confirmPassword) {
            vm.clickedConfirmPasswordButton = true;
            ToasterService.showError($translate.instant('common.errorPasswordsNotMatching'), $translate.instant('common.error'));
            return;
        } else if (vm.currentUser.securityCode.length === 0) {
            vm.clickedConfirmPasswordButton = true;
            ToasterService.showError($translate.instant('common.errorMissingSecurityCode'), $translate.instant('common.error'));
            return;
        }

        AuthService.confirmNewPassword(vm.currentUser).then(function(response) {
            if (response !== null || response !== undefined) {
                vm.showPage = 2;
            }
        }, function(error) {
            ToasterService.showError($translate.instant(error.message), $translate.instant('common.error'));
            vm.clickedConfirmPasswordButton = false;
        });
    }

    function validateEmail(email) {
        var EMAIL_REGEXP = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;

        return EMAIL_REGEXP.test(email);
    }
}

angular
    .module('services.dialogs.resetLoginDialog', [])
    .service('UserPasswordResetDialogService', UserPasswordResetDialogService)
    .controller('UserPasswordResetDialogServiceController', UserPasswordResetDialogServiceController);
